import React, {useEffect} from 'react';
import {Text} from 'react-aria-components';
import {LuCog} from "react-icons/lu";
import {Navigate} from "react-router-dom";

import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import {LabeledSection, LabeledTextField} from "../../components/Fields/LabeledTextField.jsx";
import DefaultButton, {SecondaryButton} from "../../components/Buttons/DefaultButton/DefaultButton";
import api from "../../utils/api";
import "./UserCreate.css";


function UserCreate() {
    const [submitting, setSubmitting] = React.useState(false)
    const [email, setEmail] = React.useState("")
    const [redirectTo, setRedirectTo] = React.useState(null)
    const [orgId, setOrgId] = React.useState("")

    async function submit() {
        setSubmitting(true)
        await api.createUser({
            email: email,
            organization_id: orgId,
            permission_level: "admin",
        }).then((r) => {
            setSubmitting(false)
            if (r) {
                setRedirectTo(`/organization_users`)
            } else {
                setRedirectTo(`/organization_user/create`)
            }
        })
    }

    useEffect(() => {
        api.getCurrentUser().then(data => {
            setOrgId(data.organizationId)
        })
    }, []);

    if (submitting) {
        return <Text>Submitting...</Text>
    }

    if (redirectTo !== null && redirectTo !== window.location.pathname) {
        return <Navigate to={redirectTo} />
    }

    const content = <div id="user-create">
        <LabeledSection label="General" icon={<LuCog/>} className="general-settings">
            <div className="labeled-text-field" aria-labelledby="email">
                <LabeledTextField
                    label="Email"
                    value={email}
                    placeholder="User Email"
                    onChange={e => {
                        setEmail(e.target.value)
                    }}
                    name="email"
                    errorLoc={["body", "email"]}
                    hiddenLabel={undefined}
                />
            </div>
        </LabeledSection>

        <div className="save-row">
            <SecondaryButton
                className="cancel-button"
                text="Cancel"
                href="/organization_users" />
            <DefaultButton text="Save" onPress={submit} oneClick />
        </div>
    </div>

    return <FullWidthLayout
        title="Add Organization User"
        mainContent={content}
    />
}

export default UserCreate;
